import ResourcesAndFeaturedRegUpdate from './ResourcesAndFeaturedRegUpdate';
import React from 'react';

const ResourcesAndFeaturedRegUpdateWithProps = (props: any) => {
  return (
    <ResourcesAndFeaturedRegUpdate
      resourceSectionTitle={props.resourceSectionTitle}
      resourceSectionDescription={props.resourceSectionDescription}
      resourceCategoryLinks={props.resourceCategoryLinks}
      resourceCtaLabel={props.resourceCtaLabel}
      resourceCtaLink={props.resourceCtaLink}
      regulatoryUpdateSectionTitle={props.regulatoryUpdateSectionTitle}
      regulatoryUpdateSectionDescription={
        props.regulatoryUpdateSectionDescription
      }
      regulatoryUpdateSectionArticle={props.regulatoryUpdateSectionArticle}
    />
  );
};

export default ResourcesAndFeaturedRegUpdateWithProps;
